<template>
  <com-page>
    <com-search :columns="searchColumns" @search="handleSearch">
      <template>
        <el-button type="primary" @click="handleCreated">新增</el-button>
      </template>
    </com-search>
    <com-card>
      <com-table ref="table" :columns="columns" :api="api">
        <template #type="row">
          {{ typeMap[row.data.type] }}
        </template>
        <template #ruleType="row">
          {{ ruleTypeMap[row.data.ruleType] }}
        </template>
        <template #operation="row">
          <el-button type="default" size="mini" @click="handleDetail(row.data)">查看</el-button>
          <el-button type="primary" size="mini" @click="handleEdit(row.data)">编辑</el-button>
          <el-button type="danger" size="mini" @click="handleDel(row.data)">删除</el-button>
        </template>
      </com-table>
    </com-card>
    <the-add-type ref="createdType" @update="update"></the-add-type>
  </com-page>
</template>

<script>
import { feeStandardListApi, delFeeStandardApi } from '@/api/fee-standards'
import theAddType from './components/the-add-type'

export default {
  components: { theAddType },
  data() {
    return {
      api: feeStandardListApi,
      searchColumns: [
        {
          label: '名称',
          prop: 'nameCondition',
          type: 'input'
        },
        {
          label: '收费规则',
          prop: 'ruleType',
          type: 'select',
          option: [
            {
              label: '充电',
              value: 1
            },
            {
              label: '超时占用',
              value: 2
            }
          ]
        },
        {
          label: '收费类型',
          prop: 'type',
          type: 'select',
          option: [
            {
              label: '功率计费',
              value: 1
            },
            {
              label: '功率+电费',
              value: 2
            },
            {
              label: '服务费+电费',
              value: 3
            },
            {
              label: '计时',
              value: 4
            }
          ]
        }
      ],
      columns: [
        {
          label: '编号',
          prop: 'number'
        },
        {
          label: '名称',
          prop: 'name'
        },
        {
          label: '收费规则',
          prop: 'ruleType',
          type: 'slot',
          slotName: 'ruleType'
        },
        {
          label: '收费类型',
          prop: 'type',
          type: 'slot',
          slotName: 'type'
        },
        {
          label: '关联小区数',
          prop: 'belongResidentialAreaCount'
        },
        {
          label: '创建人',
          prop: 'refCreateUserName'
        },
        {
          label: '创建时间',
          prop: 'createTime'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation',
          width: 250
        }
      ],
      typeMap: {
        1: '功率计费',
        2: '功率+电费',
        3: '服务费+电费',
        4: '计时'
      },
      ruleTypeMap: {
        1: '充电',
        2: '超时占用'
      }
    }
  },
  methods: {
    update() {
      this.$refs.table.getList()
    },
    handleDetail(row) {
      const params = {
        type: 'check',
        row
      }
      this.$refs.createdType.open(params)
    },
    handleEdit(row) {
      const params = {
        type: 'edit',
        row
      }
      this.$refs.createdType.open(params)
    },
    handleCreated() {
      const params = {
        type: 'created'
      }
      this.$refs.createdType.open(params)
    },
    handleSearch(val) {
      this.$refs.table.search(val)
    },
    handleDel(row) {
      this.$confirm('是否确认删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            code: row.code
          }
          delFeeStandardApi(params).then((res) => {
            const { desc } = res
            this.$message.success(desc)
            this.update()
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.search_wrapper {
  width: 100%;
  padding: 20px;
  background: white;
  margin-bottom: 15px;
  border-radius: 5px;
}
</style>
